import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { ManualAdjustmentRoute } from './manual-adjustment.route';
import { EntityDataService } from '@ngrx/data';
import { entityName, ManualAdjustmentDataService } from '../data-services/manual-adjustment';



@NgModule({
  // declarations: [],
  providers: [ManualAdjustmentDataService],
  imports: [
    CommonModule,
    SharedModule,
    UIRouterModule.forChild({
      states: [ManualAdjustmentRoute]
    })
  ]
})
export class ManualAdjustmentModule {
    constructor(
        entityDataService: EntityDataService,
        manualAdjustmentService: ManualAdjustmentDataService
      ) {
        entityDataService.registerService(entityName, manualAdjustmentService);
      }
}
